/** Formats a section or wire length in millimetres for display. */
export function formatLength(mm: number): string {
  return `${mm} mm`;
}

/** Formats a wire conductor cross-section in mm² for display. */
export function formatGauge(mm2: number): string {
  return `${mm2} mm²`;
}
